import { AuthService } from '@App/app/auth/auth.service';
import { selectEndpoints } from '@App/app/auth/store/auth/selectors/auth.selectors';
import { Endpoint } from '@App/app/entities/auth/endpoint.model';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CompanySelectionService {
  constructor(private router: Router, private authService: AuthService, private store: Store) {}

  loadEndpoints(callback: (endpoints: Endpoint[]) => void) {
    this.store.select(selectEndpoints).pipe(take(1)).subscribe(callback);
  }

  checkFreshLogin(route: ActivatedRoute, callback: () => void) {
    route.queryParams.subscribe((params) => {
      if (params['freshLogin']) {
        callback();
      }
    });
  }

  onAdminPanelClick() {
    this.router.navigate([`/admin-panel`]);
  }

  onClick(endpoint: Endpoint) {
    this.authService.setCurrentEndpoint(endpoint);
    this.router.navigate([`/${endpoint.id}/models`]);
  }
}
